import { smartDocParamResolver_NavigationResponse, smartDocParamResolver_Order, smartDocParamResolver_WorkingDiagnosis } from '../../smart-doc-param-resolver/index.js';
import { smartDocExternalParam_ParamKey_DispositionType, smartDocExternalParam_ParamKey_WorkingDiagnosisId } from './param-key.js';
import { smartDocExternalParamType_API, smartDocExternalParamType_FreeText, smartDocExternalParamType_NavigationResponse, smartDocExternalParamType_Order, } from './types.js';
export const smartDocExternalParamTypeLabelMap = {
    [smartDocExternalParamType_FreeText]: 'Free Text',
    [smartDocExternalParamType_NavigationResponse]: 'Navigation Response',
    [smartDocExternalParamType_Order]: 'Order',
    [smartDocExternalParamType_API]: 'API'
};
export const getExternalParamResolvers = (externalParam) => {
    switch (externalParam?.subType) {
        case smartDocExternalParamType_FreeText:
            return [];
        case smartDocExternalParamType_NavigationResponse:
            return [...smartDocParamResolver_NavigationResponse];
        case smartDocExternalParamType_Order:
            return [...smartDocParamResolver_Order];
        case smartDocExternalParamType_API: {
            switch (externalParam.paramKey) {
                case smartDocExternalParam_ParamKey_DispositionType:
                    return [];
                case smartDocExternalParam_ParamKey_WorkingDiagnosisId:
                    return [...smartDocParamResolver_WorkingDiagnosis];
                default:
                    return [];
            }
        }
        default:
            return [];
    }
};
//# sourceMappingURL=consts.js.map